// eslint-disable-next-line no-unused-vars
import * as React from "react";
import { Box, styled } from "@mui/material";

export const Container = styled(Box)(
    ({ theme }) => `
        margin-top: 48px;
        max-width: 436px;
        max-height: calc(100vh - 48px);
        background: ${theme.palette.background.paper};
        display: flex;
        flex-direction: column;
        flex-grow: 2;
        overflow-y: auto;
`
);